module.exports = __webpack_public_path__ + "static/img/case.5794b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/commonPage/img/case.png
// module id = /+23
// module chunks = 1